const styles = {
  "alert-success": {
    color: "#0f5132",
    backgroundColor: "#d1e7dd",
    borderColor: "#badbcc",
  },
  "alert-danger": {
    color: "#842029",
    backgroundColor: "#f8d7da",
    borderColor: "#f5c2c7",
  },
  "alert-warning": {
    color: "#664d03",
    backgroundColor: "#fff3cd",
    borderColor: "#ffecb5",
  },
}

export default styles
